module.exports = __webpack_public_path__ + "static/media/dashboard-copy.22741143.svg";